// Billing lives in the accounts app now — cadam only links out to it.
// Plans / manage / credits all live on this page; `#upgrade` opens the
// upgrade flow directly.
export const BILLING_URL = 'https://accounts.adam.new/billing';
export const BILLING_UPGRADE_URL = `${BILLING_URL}#upgrade`;
